import { HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { CoreApiService } from '../core-api.service';
import { FileStatus } from './upload.model';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  constructor(
    private coreApi: CoreApiService,
  ) { }

  uploadFile(status: FileStatus, containerId: string): Observable<number> {
    const formData = new FormData();
    formData.append('file', status.file, status.file.name);
    if (status.fileType !== null) {
      formData.set('metadata', JSON.stringify({ type: status.fileType }));
    }
    return this.coreApi.containers.files.upload(containerId, formData).pipe(
      switchMap(event => {
        switch (event.type) {
          case HttpEventType.UploadProgress: return of(Math.floor((event.loaded / event.total) * 100));
          case HttpEventType.Response: return of(100);
          default: return EMPTY;
        }
      })
    );
  }
}
